var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7333 11.2556L10.8892 5.94336H9.11133L9.27116 11.2556H10.7333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.32269 13.9493C9.51177 14.1358 9.73819 14.2289 10.0019 14.2289C10.1723 14.2289 10.3294 14.1863 10.4733 14.1011C10.6171 14.0133 10.7329 13.8973 10.8209 13.7536C10.9114 13.6071 10.958 13.4459 10.9607 13.2702C10.958 13.0092 10.8608 12.7854 10.669 12.599C10.4773 12.4126 10.2549 12.3193 10.0019 12.3193C9.73819 12.3193 9.51177 12.4126 9.32269 12.599C9.13361 12.7854 9.04036 13.0092 9.04302 13.2702C9.04036 13.5338 9.13361 13.7602 9.32269 13.9493Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 18.3332C14.6017 18.3332 18.3327 14.6022 18.3327 9.99984C18.3327 5.39746 14.6017 1.6665 9.99935 1.6665C5.39697 1.6665 1.66602 5.39746 1.66602 9.99984C1.66602 14.6022 5.39697 18.3332 9.99935 18.3332ZM9.99935 16.6665C13.6813 16.6665 16.666 13.6818 16.666 9.99984C16.666 6.31794 13.6813 3.33317 9.99935 3.33317C6.31745 3.33317 3.33268 6.31794 3.33268 9.99984C3.33268 13.6818 6.31745 16.6665 9.99935 16.6665Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alertCircle.ff540e650cfb50791e5eff58eed7bc5f.svg";
export { ForwardRef as ReactComponent };